import api from "api/api";
import { invalidroutes } from "App";
import { openDB } from "idb";
import { generateFilename } from "version2/utils/filename";


export const UploadindexdbRecording = async () => {
  try {
    async function initDB() {
      const db = await openDB("audioDB", 3, {
        upgrade(db) {
          if (!db.objectStoreNames.contains("audioStore")) {
            db.createObjectStore("audioStore", { keyPath: "practiceid", autoIncrement: true });
          }
        },
      });
    
      return db;
    }
    
     
const db= await initDB();
    // const db = await openDB("audioDB", 3);
    const tx = db.transaction("audioStore", "readwrite");
    const store = tx.objectStore("audioStore");

    // Get all records from IndexedDB
    const allRecords = await store.getAll();
    const now = new Date();

    // Filter out records older than 30 minutes
    const validRecords = allRecords.filter((record) => {
      const createdAt = new Date(record.createdAt);
      const diffInMinutes = (now - createdAt) / (1000 * 60);
      return diffInMinutes <= 30;
    });

    // Delete old records that exceed 30 minutes
    for (const record of allRecords) {
      const createdAt = new Date(record.createdAt);
      const diffInMinutes = (now - createdAt) / (1000 * 60);
      if (diffInMinutes > 30) {
        await store.delete(record.practiceid);
        console.log(`Deleted old record with practiceid: ${record.practiceid}`);
      }
    }

    await tx.done;

    console.log("Remaining audio records:", validRecords);

    if (validRecords.length) {
      
if (invalidroutes.includes(window.location.pathname)) {
return
}
 const currentuser= await api.get('/auth/me')

      for (const record of validRecords) {
        if (record.isUploading) {
          console.log(`Skipping record ${record.practiceid} as it's already uploading`);
          continue;
        }
if(record.userid!=currentuser?.id){
  console.log('record is not matched to user')
  return
}

const updateDB = await openDB("audioDB", 3);
const updateTx = updateDB.transaction("audioStore", "readwrite");
const updateStore = updateTx.objectStore("audioStore");
await updateStore.put({ ...record, isUploading: true });
await updateTx.done;

let obj={
  fileExtension:'txt',
  file:record.file,
  practiceid:record.practiceid,
  departmentid:record.departmentid,
  patientname:record.patientname,
  currentUser:record.role,
}
        const formData = new FormData();
        if(record.status==='edit'){
            formData.append("file", record.file);
            formData.append("departmentid", record.departmentid);
            formData.append("category", record.category);
            formData.append("patientname", record.patientname);
            formData.append("practiceid", record.practiceid);
            formData.append("patientid", record.patientid);
           obj.patientid=record.patientid
            formData.append('notes',record.notes)
            formData.append('tags',record.tags);
          obj.rowid=record.rowid
          obj.filename=record.streamingfilename
          obj.category=record.category
            formData.append("rowid", record. rowid);
            formData.append("filename", record. streamingfilename);
            if(record.role=='BUSINESS'){
             
            }else if(record.role=='PLUS'||record.role=='BASIC'){
              formData.append("template_name", record.templatename);
            }else{
              formData.append("template_name", record.templatename);
              formData.append("appointmentid", record.appointmentid);
              obj. appointmentid=record.appointmentid
            }

        }else{
            if(record.role=='BUSINESS'){
                formData.append("file", record.file);
                formData.append("practiceid", record.practiceid);
                formData.append("departmentid", record.departmentid);
                formData.append("patientid", 10000);
                formData.append('notes',record.notes)
                formData.append('tags',record.tags);
                obj.patientid=1000
            
            }else if(record.role=='PRO'){
              formData.append("file", record.file);
              formData.append("practiceid", record.practiceid);
              formData.append("departmentid", record.departmentid);
              formData.append('notes',record.notes)
              formData.append('tags',record.tags);
              formData.append("patientid", record.patientid);
              obj.patientid=record.patientid
              formData.append("patientname", record.patientname);
              formData.append("appointmentid", record.appointmentid);
              formData.append("template_name", record.templatename);
              obj. appointmentid=record.appointmentid
      if(record.category=='combine'){
        formData.append("rowid", record. rowid);
        formData.append("category", record.category);
        formData.append("filename", record. streamingfilename);
        obj.rowid=record.rowid
        obj.filename=record.streamingfilename
        obj.category=record.category
      }

            }  else {
        formData.append("patientid", record.patientid);
        obj.patientid=record.patientid
            formData.append("departmentid", record.departmentid);
            formData.append("patientname", record.patientname);
            formData.append("template_name", record.templatename);
            formData.append("practiceid", record.practiceid);
            formData.append("file", record.file);
    
            }
        }
            const generatedfilename=generateFilename(obj)
            formData.append('generated_file_name',generatedfilename)

        try {
          if(record.role=='PRO'){
 await api.put('v1/appointments/status',{
                "appointment_id": record.appointmentid,
                "status":'active'
              })

          }
          // generated_file_name: 9928_1_1468_590158_20250409153255.txt
          const response = await api.post(
            `/v1/recording/combine_transcript/?stream_filename=${record?.filename}`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );

          // Delete record immediately if API response is 200
          if (response.status === 200) {
            console.log(`Successfully uploaded record: ${record.practiceid}`);
            const deleteDb = await openDB("audioDB", 3); // Ensure a new transaction
            const deleteTx = deleteDb.transaction("audioStore", "readwrite");
            console.log(record.practiceid,'recordpractice id')
            await deleteTx.objectStore("audioStore").delete(record.practiceid);
            await deleteTx.done;
            console.log(`Deleted record after successful upload: ${record.practiceid}`);
          }
        } catch (uploadError) {
          console.error(`Error uploading record ${record.practiceid}:`, uploadError);
          const failTx = db.transaction("audioStore", "readwrite");
          const failStore = failTx.objectStore("audioStore");
          await failStore.put({ ...record, isUploading: false });
          await failTx.done;
        }
      }
    }
  } catch (error) {
    
    console.error("Error in UploadindexdbRecording function:", error);
  }
};
